import { AppConfig } from '../shared/utils/config/app-config';

/**
 * Only unauthenticated, static-config loading happens here (see cognito-to-msal-migration
 * skill, lesson #6): any protected/backend HTTP call must run AFTER `MsalGuard` has
 * activated a route, never eagerly at bootstrap — otherwise `MsalInterceptor` can attempt
 * a premature interactive redirect that silently blocks the real, later login redirect.
 * Protected calls (bundles, sales contexts, pipeline data) are handled in `AppComponent`
 * once `MsalBroadcastService.inProgress$` reaches `InteractionStatus.None`.
 */
export const initializer =
	(config: AppConfig): (() => Promise<any>) =>
	(): Promise<any> =>
		// eslint-disable-next-line no-async-promise-executor
		new Promise(async (resolve, reject) => {
			try {
				await config.load();
				resolve(true);
			} catch (error) {
				console.log(error);
				reject(error);
			}
		});
